import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const Scintilla2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/Scintilla/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/Scintilla/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/Scintilla/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/Scintilla/4.webp`;
    const p5  = `${config.base_image_url_2025}/home/events-activities/school-programs/Scintilla/5.webp`;
    const p6  = `${config.base_image_url_2025}/home/events-activities/school-programs/Scintilla/6.webp`;
    const p7  = `${config.base_image_url_2025}/home/events-activities/school-programs/Scintilla/7.webp`;
    const p8  = `${config.base_image_url_2025}/home/events-activities/school-programs/Scintilla/8.webp`;
    const p9  = `${config.base_image_url_2025}/home/events-activities/school-programs/Scintilla/9.webp`;
    const p10 = `${config.base_image_url_2025}/home/events-activities/school-programs/Scintilla/10.webp`;
    const p11 = `${config.base_image_url_2025}/home/events-activities/school-programs/Scintilla/11.webp`;
    

   
    const photos = [
         {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
}, 
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
},
{
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},
{
  src: p9,
  source: p9,
  rows: 1,
  cols: 1,
},
{
  src: p10,
  source: p10,
  rows: 1,
  cols: 1,
},
{
  src: p11,
  source: p11,
  rows: 1,
  cols: 1,
}

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                              SCINTILLA OF ART 2025-26
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                              Class: 10     Date: 16 September 2025
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The Annual Art Exhibition, Scintilla of Art, was inaugurated on Tuesday, 16 September 2025, by
                                our Principal, Ms. Sheeja Manoj. The event commenced with great enthusiasm as the students of Class 10 proudly presented an exquisite array of their creative works.
                                <br></br>
                                The exhibition featured a diverse collection of artistic and handcrafted pieces, including vibrant paintings, elegant jewellery, and decorative items. A few of the plants were grown by the students themselves and were sold during the event, further highlighting the hands-on effort and creativity involved. 
                                <br></br>
                               A special highlight of the event was the NPS Café, thoughtfully managed by the student teams, offering an assortment of delectable treats such as chaats, sandwiches, juices, nachos, cupcakes, cookies, and homemade chocolates, much to the delight of visitors.
                               <br></br>
                                The event witnessed enthusiastic participation from teachers and students alike, who generously supported the stalls, contributing to the fundraising initiative. The exhibition was a resounding success, providing students not only with a platform to showcase their artistic and entrepreneurial skills but also an opportunity to make a meaningful contribution to the society. All proceeds from the event will be donated to an orphanage, making the day truly memorable and impactful.
                               <br></br>
                                </Typography>
                            </Box>
                            {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ The strength of a democracy lies in the ability of its citizens to question, engage, and actively participate in shaping its future.”

                                <br />
                            </Typography> */}

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Scintilla2025;